<template>
    <div class="location" :class="`location-${variant}`">
        <span v-if="icon || reserveIcon" class="icon material-symbols-outlined">
            {{ icon }}
        </span>
        <div class="location-name">
            <router-link v-if="nameHead" :to="target">{{
                nameHead
            }}</router-link>
            <span class="name-tail">
                <router-link :to="target">{{ nameTail }}</router-link>
                <span class="location-meta">
                    <span v-if="showNights" class="nights-badge">
                        <span class="icon material-symbols-outlined">
                            nights_stay
                        </span>
                        {{ location.nights }}
                        {{ location.nights === 1 ? "night" : "nights" }}
                    </span>
                    <ImpressionWidget
                        :value="location.impression"
                        @updated="$emit('impression-updated', $event)"
                    />
                </span>
            </span>
        </div>
    </div>
</template>

<script>
import ImpressionWidget from "js/components/widgets/ImpressionWidget";

export default {
    name: "LocationHeadline",
    components: {
        ImpressionWidget,
    },
    props: {
        location: {
            type: Object,
            required: true,
        },
        variant: {
            type: String,
            default: "top",
            validator: (value) => ["top", "nested", "transit"].includes(value),
        },
        icon: {
            type: String,
            default: null,
        },
        reserveIcon: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["impression-updated"],
    computed: {
        target() {
            return {
                name: this.$route.name,
                hash: `#location-${this.location.id}`,
            };
        },
        showNights() {
            return this.variant === "top" && this.location.nights > 0;
        },
        lastSpace() {
            return this.location.name.trimEnd().lastIndexOf(" ");
        },
        nameHead() {
            return this.location.name.slice(0, this.lastSpace + 1);
        },
        nameTail() {
            return this.location.name.slice(this.lastSpace + 1).trimEnd();
        },
    },
};
</script>
